'use client';

import { c as _c } from "react/compiler-runtime";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@repo/ui/components';
import { cn } from '@repo/ui/lib/utils';
import type { TimePickerMode, TimeType } from './types';
import { getDefaultForType, useTimePicker } from './provider';
const collectionOptions: Array<{
  label: string;
  value: TimeType;
}> = [{
  label: 'Between',
  value: 'between'
}, {
  label: 'At',
  value: 'at'
}, {
  label: 'Before',
  value: 'by'
}, {
  label: 'TBC',
  value: 'tbc'
}, {
  label: 'ASAP',
  value: 'asap'
}];
const deliveryOptions: Array<{
  label: string;
  value: TimeType;
}> = [{
  label: 'ASAP',
  value: 'asap'
}, {
  label: 'Before',
  value: 'by'
}, {
  label: 'At',
  value: 'at'
}, {
  label: 'Between',
  value: 'between'
}, {
  label: 'TBC',
  value: 'tbc'
}];
const schemaOptions: Array<{
  label: string;
  value: TimeType;
}> = [{
  label: 'Between',
  value: 'between'
}, {
  label: '24 Hours',
  value: '24'
}, {
  label: 'At',
  value: 'at'
}, {
  label: 'Before',
  value: 'by'
}, {
  label: 'TBC',
  value: 'tbc'
}, {
  label: 'ASAP',
  value: 'asap'
}];
const getOptions = (mode: TimePickerMode) => mode === 'collection' ? collectionOptions : mode === 'delivery' ? deliveryOptions : schemaOptions;
type TimePickerTypeSelectorProps = {
  className?: string;
  onOpenChange?: (open: boolean) => void;
};
export const TimePickerTypeSelector = t0 => {
  const $ = _c(49);
  const {
    className,
    onOpenChange
  } = t0;
  const {
    disabled,
    invalid,
    mode,
    setValue,
    size,
    value
  } = useTimePicker();
  let t1;
  if ($[0] !== mode || $[1] !== setValue) {
    t1 = type => {
      if (type) {
        setValue(getDefaultForType(mode, type));
      }
    };
    $[0] = mode;
    $[1] = setValue;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleChange = t1;
  let T0;
  let T1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== className || $[4] !== disabled || $[5] !== handleChange || $[6] !== invalid || $[7] !== mode || $[8] !== onOpenChange || $[9] !== size || $[10] !== value.type) {
    const options = getOptions(mode);
    T1 = Select;
    t5 = disabled;
    t6 = options;
    t7 = onOpenChange;
    t8 = handleChange;
    t9 = value.type;
    t10 = "Select";
    t11 = "TimePickerTypeSelector";
    t12 = "type-selector.tsx";
    const t14 = size === "large" && "data-[size=default]:h-9";
    let t15;
    if ($[25] !== className || $[26] !== t14) {
      t15 = cn("w-full", t14, className);
      $[25] = className;
      $[26] = t14;
      $[27] = t15;
    } else {
      t15 = $[27];
    }
    let t16;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <SelectValue placeholder="Time" data-sentry-element="SelectValue" data-sentry-source-file="type-selector.tsx" />;
      $[28] = t16;
    } else {
      t16 = $[28];
    }
    if ($[29] !== invalid || $[30] !== t15) {
      t13 = <SelectTrigger aria-invalid={invalid} className={t15} data-sentry-element="SelectTrigger" data-sentry-source-file="type-selector.tsx">{t16}</SelectTrigger>;
      $[29] = invalid;
      $[30] = t15;
      $[31] = t13;
    } else {
      t13 = $[31];
    }
    T0 = SelectContent;
    t2 = "SelectContent";
    t3 = "type-selector.tsx";
    t4 = options.map(_temp);
    $[3] = className;
    $[4] = disabled;
    $[5] = handleChange;
    $[6] = invalid;
    $[7] = mode;
    $[8] = onOpenChange;
    $[9] = size;
    $[10] = value.type;
    $[11] = T0;
    $[12] = T1;
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    T0 = $[11];
    T1 = $[12];
    t10 = $[13];
    t11 = $[14];
    t12 = $[15];
    t13 = $[16];
    t2 = $[17];
    t3 = $[18];
    t4 = $[19];
    t5 = $[20];
    t6 = $[21];
    t7 = $[22];
    t8 = $[23];
    t9 = $[24];
  }
  let t14;
  if ($[32] !== T0 || $[33] !== t2 || $[34] !== t3 || $[35] !== t4) {
    t14 = <T0 data-sentry-element={t2} data-sentry-source-file={t3}>{t4}</T0>;
    $[32] = T0;
    $[33] = t2;
    $[34] = t3;
    $[35] = t4;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== T1 || $[38] !== t10 || $[39] !== t11 || $[40] !== t12 || $[41] !== t13 || $[42] !== t14 || $[43] !== t5 || $[44] !== t6 || $[45] !== t7 || $[46] !== t8 || $[47] !== t9) {
    t15 = <T1 disabled={t5} items={t6} onOpenChange={t7} onValueChange={t8} value={t9} data-sentry-element={t10} data-sentry-component={t11} data-sentry-source-file={t12}>{t13}{t14}</T1>;
    $[37] = T1;
    $[38] = t10;
    $[39] = t11;
    $[40] = t12;
    $[41] = t13;
    $[42] = t14;
    $[43] = t5;
    $[44] = t6;
    $[45] = t7;
    $[46] = t8;
    $[47] = t9;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  return t15;
};
function _temp(t0) {
  const {
    label,
    value: value_0
  } = t0;
  return <SelectItem key={value_0} value={value_0}>{label}</SelectItem>;
}